import { useEffect } from 'react';

import { useAppSelector } from '@/hooks/redux-hooks';

interface IThemeProviderProps {
  children: JSX.Element,
}

const ThemeProvider = ({ children }: IThemeProviderProps) => {
  const { theme } = useAppSelector((state) => state.themeReducer);
  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem('theme', theme);
  }, [theme]);

  return children;
};

export default ThemeProvider;
